"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { User, Package, CreditCard, LogOut, Heart, Truck, CalendarClock } from "lucide-react"
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar"

interface CustomerSidebarProps {
  isMobileSidebarOpen: boolean
  setIsMobileSidebarOpen: (open: boolean) => void
}

export default function CustomerSidebar({ isMobileSidebarOpen, setIsMobileSidebarOpen }: CustomerSidebarProps) {
  const pathname = usePathname()

  const menuItems = [
    {
      title: "Начало",
      icon: <User className="h-5 w-5" />,
      href: "/customer/profile",
    },
    {
      title: "Поръчки",
      icon: <Package className="h-5 w-5" />,
      href: "/customer/orders",
    },
    {
      title: "Моите любимци",
      icon: <Heart className="h-5 w-5" />,
      href: "/customer/pet",
    },
    {
      title: "Регулярна доставка",
      icon: <Truck className="h-5 w-5" />,
      href: "/customer/autoship",
    },
    {
      title: "Абонаменти",
      icon: <CalendarClock className="h-5 w-5" />,
      href: "/customer/subscriptions",
    },
    {
      title: "Банкова карта",
      icon: <CreditCard className="h-5 w-5" />,
      href: "/customer/bank-card",
    },
    {
      title: "Изход",
      icon: <LogOut className="h-5 w-5" />,
      href: "/api/auth/logout",
    },
  ]

  const handleClick = () => {
    if (isMobileSidebarOpen) {
      setIsMobileSidebarOpen(false)
    }
  }

  return (
    <Sidebar collapsible="none" className="border-none shadow-none">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={pathname === item.href} onClick={handleClick}>
                    <Link href={item.href} className="flex items-center gap-3">
                      {item.icon}
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
